const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const CDN_URL = import.meta.env.CDN_URL;
const SHA_VERSION = import.meta.env.VITE_SHA_VERSION;
const CRISP_WEBSITE_ID = import.meta.env.VITE_CRISP_WEBSITE_ID;

export default {
  VITE_API_BASE_URL,
  CDN_URL,
  SHA_VERSION,
  CRISP_WEBSITE_ID,
};
